import { render, staticRenderFns } from "./AppOnderpanden.vue?vue&type=template&id=f44a29c8&scoped=true&"
import script from "./AppOnderpanden.ts?vue&type=script&lang=ts&"
export * from "./AppOnderpanden.ts?vue&type=script&lang=ts&"
import style0 from "./AppOnderpanden.scss?vue&type=style&index=0&id=f44a29c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44a29c8",
  null
  
)

export default component.exports